import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detailed-report-faq',
  templateUrl: './detailed-report-faq.component.html',
  styles: []
})
export class DetailedReportFaqComponent implements OnInit {
@Input() isCombinedReport: boolean;
  constructor() { }

  ngOnInit() {
  }

}
